import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { update, deleteOne } from '../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const UpdateEvent = ({ updateEventModal, event, metadata, prefs, onModalCose }) => {
    const [formData, setFormData] = React.useState({
        start_time: '',
        end_time: ''
    });

    React.useEffect(() => {
        if (event && event.start && event.end) {
            setFormData({
                start_time: event.start.toISOString().slice(0, 16),
                end_time: event.end.toISOString().slice(0, 16)
            });
        }
    }, [event]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            await update('/admin/campaigns/scheduler/events/', event.eventId, { data: formData });
            toast.success('Event updated successfully');
            onModalCose();
        } catch (error) {
            toast.error('Error updating event: ' + error.message);
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this event?')) {
            try {
                await deleteOne('/admin/campaigns/scheduler/events/', event.eventId);
                toast.success('Event deleted successfully');
                onModalCose();
            } catch (error) {
                toast.error('Error deleting event: ' + error.message);
            }
        }
    };

    const handleClose = () => {
        onModalCose();
    };

    if (!event) return null;

    return (
        <Modal show={updateEventModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Update Campaign Event</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Campaign</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={event.title || 'Unknown Campaign'}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Start Date & Time</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    name="start_time"
                                    value={formData.start_time}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>End Date & Time</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    name="end_time"
                                    value={formData.end_time}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={event.status || 'Unknown'}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleDelete} className="me-auto">
                        Delete Event
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit">
                        Update Event
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdateEvent;
